import { SRow } from '@avalara/skylab-sdk/react';

import ResourceTile from './resource-tile';

import type { Content } from '../../../../types';

type ResourceProps = {
  content: Array<Content>;
};

const Resources = ({ content }: ResourceProps) => (
  <SRow className='justify-content-center'>
    {content.map(({ title, textContent, buttonText, link }) => (
      <ResourceTile title={title} textContent={textContent} buttonText={buttonText} link={link} key={title} />
    ))}
  </SRow>
);
export default Resources;
